// Contatto WhatsApp di Gianluca B. per acquisti, upgrade e attivazione moduli.
// Sostituisce ogni flusso di pagamento self-service.
export const WHATSAPP_CONTACT_NAME = "Gianluca B.";
export const WHATSAPP_CONTACT_PHONE = "+39 392 362 2456";
const WHATSAPP_NUMBER = "393923622456";

export function buildWhatsAppUrl(message?: string): string {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export function openWhatsAppContact(message?: string): void {
  const url = buildWhatsAppUrl(
    message ??
      `Ciao Gianluca, vorrei attivare/aggiornare il mio piano LexAI Pro. Puoi aiutarmi?`,
  );
  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
